import Button from "../Button/Button";
import {useTranslation} from "react-i18next";
import {useRef, useState, useLayoutEffect, useCallback} from "react";
import styles from './TestimonialInput.module.scss';
import testAvatar from "../../../static/imgs/testAvatar.png";

interface IProps {
  placeholder: string
  avatarSize: number
  valueHandler: (value: string) => void
  sendHandler: () => void
  disabledFlag: boolean
  avatarShow?: boolean;
}

const MIN_LINES = 2; // скільки рядків влазить без розширення
const MAX_LINES = 6; // скільки максимум дозволяємо рости

const TestimonialInput = ({ placeholder, avatarSize, valueHandler, sendHandler, disabledFlag, avatarShow = true }: IProps) => {
  const {t} = useTranslation();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [value, setValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const adjustHeight = useCallback(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    // скидаємо, щоб коректно зчитати новий scrollHeight
    textarea.style.height = 'auto';

    const computedStyle = window.getComputedStyle(textarea);
    const lineHeight = parseInt(computedStyle.lineHeight, 10) || 30;
    const paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
    const paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;

    const minHeight = lineHeight * MIN_LINES + paddingTop + paddingBottom;
    const maxHeight = lineHeight * MAX_LINES + paddingTop + paddingBottom;

    const newHeight = Math.min(Math.max(textarea.scrollHeight, minHeight), maxHeight);
    textarea.style.height = `${newHeight}px`;
  }, []);

  useLayoutEffect(() => {
    adjustHeight();
  }, [value, adjustHeight]);

  return (
    <div className={styles.wrapper}>
      {avatarShow && (
        <div className={styles.avatarWrapper}>
          <img src={testAvatar} alt="avatar" width={avatarSize} height={avatarSize} />
        </div>
      )}

      <div className={`${styles.inputWrapper} ${isFocused ? styles.focused : ''}`}>
        <textarea
          ref={textareaRef}
          className={styles.input}
          placeholder={placeholder}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={(e) => {
            setValue(e.target.value)
            valueHandler(e.target.value)
          }}
          value={value}
        />
        <Button
          disabled={disabledFlag}
          title={t('sendComment')}
          submit={() => {
            sendHandler();
            setValue('');
          }}
          className={styles.btn}
        />
      </div>
    </div>
  )
}

export default TestimonialInput;
